import { makeStyles } from "tss-react/mui";
import bannerImage from "../images/banners/kirke-photo-banner-001.webp";

type Props = {
  topRef?: React.Ref<HTMLDivElement>;
  // handleContactOpenCB: (value: boolean) => void;
};

const useStyles = makeStyles()((theme) => ({
  bannerImage: {
    width: "100%",
    height: "auto",
  },
}));

// const BannerComponent: React.FC<Props> = ({ topRef, handleContactOpenCB }) => {
const BannerComponent: React.FC<Props> = ({ topRef }) => {
  const { classes } = useStyles();

  return (
    // <div ref={topRef} onClick={() => handleContactOpenCB(true)}>
    <div ref={topRef}>
      <img
        src={bannerImage}
        alt="kirke-band-banner-photo"
        title="kirke-band-banner-photo"
        className={classes.bannerImage}
        loading="lazy"
      />
    </div>
  );
};

export default BannerComponent;
